import {
    FETCHING_SKILLS_REQUEST,
    FETCHING_SKILLS_SUCCEEDED,
    FETCHING_SKILLS_FAILED,
    CREATING_SKILL_REQUEST,
    CREATING_SKILL_SUCCEEDED,
    CREATING_SKILL_FAILED,
    DELETING_SKILL_REQUEST,
    DELETING_SKILL_SUCCEEDED,
    DELETING_SKILL_FAILED,
    UPDATING_SKILL_FAILED,
    UPDATING_SKILL_SUCCEEDED,
    UPDATING_SKILL_REQUEST
}
    from "../actions/actionTypes";

const initialState = {
    loading: false,
    items: {
        pagination: {
            currentPage: 0,
            totalPages: 0,
            totalRecordsCount: 0
        }, 
        records: []
    },
    creating: false,
    updating: false,
    error: null
}

function skillReducer(state = initialState, action) {
    switch (action.type) {
        case FETCHING_SKILLS_REQUEST:
            return Object.assign({}, state, {
                ...state,
                loading: true,
                isFetched: false,
            })

        case FETCHING_SKILLS_SUCCEEDED: {
            let records = [];
            if(action.payload.currentPage == 0) {
                records = [...action.payload.records];
            } else {
                records = [...state.items.records, ...action.payload.records];
            }

            return {
                ...state,
                loading: false,
                items: {
                    pagination: {
                        currentPage: action.payload.currentPage,
                        totalPages: action.payload.totalPages,
                        totalRecordsCount: action.payload.totalRecordsCount
                    },
                    records: records
                },
                isFetched: true
            };
        }

        case FETCHING_SKILLS_FAILED:
            return Object.assign({}, state, {
                ...state,
                loading: false,
                error: action.payload
            })
        case CREATING_SKILL_REQUEST:
            return Object.assign({}, state, {
                ...state,
                creating: true
            })

        case CREATING_SKILL_SUCCEEDED: {
            var items = { ...state.items };
            items.records = [...items.records, action.payload];

            return {
                ...state,
                creating: false,
                items: items
            };
        }
        case CREATING_SKILL_FAILED:
            return Object.assign({}, state, {
                ...state,
                creating: false,
                error: action.payload
            })
        case DELETING_SKILL_REQUEST:
            return Object.assign({}, state, {
                ...state,
                deleting: true
            })

        case DELETING_SKILL_SUCCEEDED: {
            let items = state.items.filter((item, index) => {
                return item.id != action.payload.id;
            })

            return Object.assign({}, state, {
                ...state,
                deleting: false,
                items: items
            })
        }

        case DELETING_SKILL_FAILED:
            return Object.assign({}, state, {
                ...state,
                deleting: false,
                error: action.payload
            })

        case UPDATING_SKILL_REQUEST: {
            return Object.assign({}, state, {
                ...state,
                updating: true,
            })
        }

        case UPDATING_SKILL_SUCCEEDED: {
            var id = action.payload.id;

            let items = state.items.records.map((item) => {
                if (item.id != id) {
                    return item;
                }

                return {
                    ...item,
                    ...action.payload.response
                };
            });

            return {
                ...state,
                updating: false,
                items: {
                    ...state.items,
                    records: items
                }
            };
        }


        case UPDATING_SKILL_FAILED: {
            return Object.assign({}, state, {
                ...state,
                updating: false,
                error: action.payload.error
            })
        }

        default:
            return state;
    }
}

export { skillReducer };